module.exports = __webpack_public_path__ + "img/Arrow Up.a603f9b8.svg";